var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":_vm.$baseUrl + '/Base_Manage/Upload/FileWXObsimg',"headers":{
    Authorization: _vm.token,
  },"show-file-list":false,"on-success":_vm.handleAvatarSuccess,"before-upload":_vm.beforeAvatarUpload}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }